import { Box, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import React from "react";
import { useSelector } from "react-redux";

const ContractorTab = ({ selectedPermitType }) => {
  const { selectedRow } = useSelector((state) => state.myPermitsComponent);

  // Helper function to get contractor data for the selected permit type
  const getContractorData = () => {
    if (!selectedRow) return null;

    // For notarization requests, the contractor data is directly in selectedRow.contractor
    if (selectedRow.contractor) {
      return selectedRow.contractor;
    }

    // If it's the main permit type, return main contractor
    if (selectedPermitType && selectedPermitType === selectedRow.permit_type) {
      return selectedRow.contractor;
    }

    // If it's an additional permit, find it in additional_permits
    if (
      selectedPermitType &&
      selectedRow.additional_permits &&
      selectedRow.additional_permits[selectedPermitType]
    ) {
      const additionalPermit =
        selectedRow.additional_permits[selectedPermitType];
      const permitData = Array.isArray(additionalPermit)
        ? additionalPermit[0]
        : additionalPermit;
      return permitData?.contractor;
    }

    return selectedRow.contractor; // fallback to main contractor
  };

  const contractorData = getContractorData();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          pt: 1,
          boxSizing: "border-box",
          flex: 1,
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: 0,
        }}
      >
        <img
          alt="contractor"
          src="/img/website_img/contractor_img.png"
          style={{
            width: "100%",
            maxWidth: "5rem",
            height: "auto",
            borderRadius: "20px",
          }}
        />
        {contractorData ? (
          <>
            <Typography mt={1} fontWeight="bold">
              {contractorData?.businessName}
            </Typography>
            <Typography mt={-0.5} fontWeight="bold">
              {contractorData?.licenseType}
            </Typography>
            <Typography mt={-0.5} fontWeight="bold">
              {contractorData?.licenseNumber}
            </Typography>
            <Box mt={6}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <LocationOnIcon />
                <Typography>{contractorData?.mainAddress}</Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <LocationOnIcon />
                <Typography>{contractorData?.mainAddressCounty}</Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <EmailIcon />
                <Typography>{contractorData?.email}</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mb: 0.5,
                }}
              >
                <PhoneIcon />
                <Typography>{contractorData?.mobile}</Typography>
              </Box>
            </Box>
          </>
        ) : (
          <Box mt={6}>
            <Typography align="center" color="text.secondary">
              No contractor information available
            </Typography>
            <Typography
              align="center"
              color="text.secondary"
              variant="body2"
              mt={1}
            >
              This may be a notarization request without contractor details
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default React.memo(ContractorTab);
